import { useContext, useEffect, useMemo, useState } from "react"
import { Contexto } from "../Context/Contexto"
import { ReferenciaDTO } from "../Model/ReferenciaDTO"
import { Mostrar } from "../Context/Mostrando"
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion"
import { Get } from "../Rutas/ApiRest"
import { Carga } from "../Rutas/Servicios"
import { tokens } from "../Context/Tokens"
import { CuponesTodosDTO } from "../Model/CuponesTodosDTO"
import { usePagination, useTable } from "react-table"
import { Cupon } from "../Model/Tablas/Cupones";

export default function Cupones ()
{
    const {Cli}=useContext(Contexto)
    const {tok}=useContext(tokens)
    const {Actualizar}=useContext(Mostrar)
    const [CuponActivo,SetCuponActivo]=useState<string>("")
    const [Contenido,SetContenido]=useState<any>("")
    const [Cupones,SetCupones]=useState<CuponesTodosDTO[]>([])
    const {SetLoading}=useContext(MensajeContActualizacion)
    const datos=[
        {}
      ]
      const columns=useMemo(() => Cupon, [])
      const dato=useMemo(() => datos, [])
      const [data,Setdata]=useState(dato)

    const Activar=(nuevoCupon:string)=>
    {
        if(nuevoCupon!=CuponActivo)
        {
            SetLoading(true);
            SetCuponActivo(nuevoCupon)
        }
    }  
    useEffect(()=>
    {
        if(CuponActivo!="")
        {
            const consulta=Get(Carga.DetalleConvenio.replace("@cupon",CuponActivo),'application/json',tok)
            consulta.then(resultado=>{SetContenido(resultado);console.log(resultado)})
        }
    },[CuponActivo])
    useEffect(()=>
    {
        SetLoading(false)
        console.log(Contenido)
    },[Contenido])

    useEffect(()=>
    {
        const consulta=Get(Carga.DescuentoConvenio.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),'application/json',tok) 
        consulta.then(resultado=>{SetCupones(resultado);Setdata(resultado)})
    },[])
    
    const { 
        getTableProps, 
    getTableBodyProps, 
    headerGroups, 
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    state,
    prepareRow,
    } = useTable({
            // @ts-ignore
            columns,
            data,
        },
        usePagination
    );
    const { pageIndex } = state

    return(
    <>
        <section className="section" id="calculadora">
                <div className="row" >
                    <div className="col-12 col-md-6" >
                            <div className="card">
                            <div className="card-body" >
                                <div className="card-body text-secondary px-sm-4" >

          <br/>
          <div className="accordion-item">
                  <h2 className="accordion-header" id="Cupon-headingOne">
                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#Cupon-collapseOne" aria-expanded="false" aria-controls="Cupon-collapseOne"> Mis Descuentos </button>
                  </h2>
                  <div id="Cupon-collapseOne" className="accordion-collapse show" aria-labelledby="Cupon-headingOne" data-bs-parent="#accordionCuponTabla">
                  <><div className="alert au-alert-success alert-dismissible fade show au-alert au-alert--100per" role="alert" id="Two"> <span className="content" >No tienes Descuentos activos para canjear.</span>

</div></>
                  </div>
                </div>
                
          
                                        
                                      <br/>         
		  </div>
                            </div>
                            </div>
                        </div>
                    <div className="col-12 col-md-6" >
        <div className="fondo-blanco h-100">
          <div className="card">
            {Contenido==""?<div className="card-body">
              <h5 className="card-title"> </h5>
              <div className="accordion" id="accordionflushTabla">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingOne">
                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne"> Preferencias de Entrega </button>
                  </h2>
                  <div id="flush-collapseOne" className="accordion-collapse show" aria-labelledby="flush-headingOne" data-bs-parent="#accordionflushTabla">
                    <div className="accordion-body">
                      <p><strong>{Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].tipoDireccion:""}</strong></p>
                      <p><strong>Región:</strong> {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].region:""}<br/>
                        <strong>Ciudad:</strong> {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].ciudad:""}<br/>
                        <strong>Comuna: </strong>{Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].comuna:""}<br/>
                        <strong>Dirección: </strong>{Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].direccion:null}<br/>
                        {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].numero!=""?<><strong>Numero:</strong>{Cli.lDirecciones[0].numero} <br/> </> :null:null}
                        {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].infoAdicional!=""?<><strong>Información complementaria: </strong>{Cli.lDirecciones[0].infoAdicional} </>:null:null}</p>
                        <p className="small"><a href="#editar" onClick={()=>{Actualizar(ReferenciaDTO.UbicacionActualizarDomicilio)}}><i className="bi bi-pen"></i> Editar información</a></p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingTwo">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo"> Lugares de Retiro </button>
                  </h2>
                  <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushTabla">
                    <div className="card-body">
                      <p><strong className="color-corporativo">LAS CONDES</strong></p>
                      <p>Avenida Padre Hurtado Central 1531<br/>
                        <strong>Horario de atención:</strong></p>
                      <p>Lunes a Viernes de 8.00 a 18.00 horario continuado </p>
                      <div className="py-3">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5934.568108564439!2d-70.54630754783449!3d-33.40593299856984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cebde799f453%3A0xfdee4ece40a93e53!2sPadre%20Hurtado%20Central%201531%2C%20Las%20Condes%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses!2scl!4v1649690732564!5m2!1ses!2scl" style={{width:"100%",height:"250",border:0}}  loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>:<>
                                <div className="card-body text-secondary px-sm-4" >
                                <p className="subtitulo" >Detalle </p>
          <div className="accordion-item">
                                    
                                    <div className="accordion-collapse collapse show" data-bs-parent="#accordionTabla">
                                   
                                    <div className="accordion-body">
                              
                                        <table className="table table-striped table-bordered" style={{width:"100%"}} cellSpacing="0" cellPadding="0">
                                            
                                            <tbody>
                                                {Contenido.usosrestantes!=undefined?Contenido.usosrestantes!=="Sin limites"?
                                              <>
                                              <tr>
                                                    <td><strong>Cupón</strong></td>
                                                    <td><span id=""><strong>{Contenido.Nombre!=undefined?Contenido.Nombre:"-"}</strong></span> </td>
                                                </tr>
                                                </>
                                              : <>
                                              <tr>
                                                    <td><strong>Descuento</strong></td>
                                                    <td><span id=""><strong>{Contenido.Nombre!=undefined?Contenido.Nombre:"-"}</strong></span> </td>
                                                </tr>
                                                </>:null  
                                              }
                                                
                                                <tr>
                                                    <td><strong>Fecha Término</strong></td>
                                                    <td><span id=""><strong>{Contenido.Fechatermino!=undefined?Contenido.Fechatermino:"Error"}</strong></span> </td>
                                                </tr>
                                                
                                                {Contenido.usosrestantes!=undefined?Contenido.usosrestantes!=="Sin limites"?<> <tr>
                                                    <td><strong>Cantidad de usos faltantes</strong></td>
                                                    <td><span id=""><strong>{Contenido.usosrestantes!=undefined?Contenido.usosrestantes:0}</strong></span> </td>
                                                </tr></>:null:null}
                                               
                                                
                                               
                                                
                                            </tbody>
                                           
                                        </table>
                                        <table className="table table-striped table-bordered" style={{width:"100%",marginTop:"-4%"}} >
                                        <tbody>
                                                <tr>
                                                    <td ><strong style={{textAlign:"center"}}>{Contenido.cupon}</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table className="table table-striped table-bordered" style={{width:"100%"}} >
                                        <tbody>
                                                <tr>
                                                    <td ><strong style={{color:Contenido.Promocion==undefined?"red":"green",textAlign:"center"}}>{Contenido.Promocion!=undefined?Contenido.Promocion:"Cupon ya usado o expirado"}</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        
                                      <br/>
                            
                                    </div>
                                    </div>
                                </div>
		
                        </div></>}
          </div>
        </div>
                </div>
                </div>
            </section>
    
    </>
    )
}